<template functional>
  <div>
    <div
      class="flex items-center gap-0.5 p-0.5"
      :class="{
        'border-dashed border border-red-500 shadow-xl': props.item.editing,
      }"
    >
      <a
        class="el-icon-edit-outline text-sm"
        :data-action="'toEdit'"
        :data-order-id="props.item.id"
      />
      <a
        v-if="
          props.options.trace &&
          (props.options.isImport(props.item) ||
            props.options.isXtown(props.item))
        "
        class="el-icon-search text-sm"
        :data-action="'showTrace'"
        :data-order-id="props.item.id"
        :data-container-no="props.item.container_no"
        :data-marker="props.item.marker"
      />
      <div class="mx-auto w-32 flex items-center gap-[1px] tracking-tighter">
        <alter-request
          :requester="{
            id: props.item.id,
            type: 'Container',
            attr: 'container_no',
          }"
          :size="14"
        >
          <e-copy
            :text="props.item.container_no"
            :show="props.item.container_no"
            showClassName="w-[74px] text-left"
            size="15"
          />
        </alter-request>
      </div>
    </div>
    <template
      v-for="o in props.item.transports
        .map((t) => t.operations)
        .flat()
        .filter((o) => o.mode)"
    >
      <alter-request
        :requester="{ id: o.id, type: 'Operation', attr: 'container_no' }"
        :size="18"
        :key="o.id"
      >
        <div class="tag">
          <e-copy :text="o.container_no" :show="o.container_no" size="16" />
        </div>
      </alter-request>
    </template>
  </div>
</template>

<script>
export default {
  name: "drayage-cont-no",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
